import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { LocationResource } from 'util/resources/Location';
import { Base } from 'active-resource';

/**
 * Relationship classes
 */
export class EmployerProfileLocationAttributes {
  emailNotifications: boolean = null;
  employerProfileId: string = null;
  id: string = null;
  locationId: string = null;
  smsNotifications: boolean = null;
}

export class EmployerProfileLocationBelongsTo {
  location: () => LocationResource = () => new LocationResource();
}

export class EmployerProfileLocationHasOne {}
export class EmployerProfileLocationHasMany {}

/**
 * Utility interfaces
 */
export interface EmployerProfileLocationMethods {}

export interface EmployerProfileLocationInterface
  extends EmployerProfileLocationAttributes,
    EmployerProfileLocationBelongsTo,
    EmployerProfileLocationType {}

type EmployerProfileLocationType = GConstructor<EmployerProfileLocationInterface>;

export interface EmployerProfileLocationResource
  extends Base<EmployerProfileLocationAttributes>,
    EmployerProfileLocationInterface,
    EmployerProfileLocationMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<EmployerProfileLocationAttributes>({
    queryName: 'employers/employer_profile_locations',
    className: 'EmployerProfileLocation',
    AttributesClass: EmployerProfileLocationAttributes,
    BelongsToClasses: [
      {
        Klass: EmployerProfileLocationBelongsTo,
      },
    ],
  });

export const EmployerProfileLocationResourceClass = <TBase extends EmployerProfileLocationType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements EmployerProfileLocationMethods {};

export class EmployerProfileLocationResource extends ClassExtender<EmployerProfileLocationInterface>(
  BaseClass,
  EmployerProfileLocationResourceClass,
) {}

/**
 * Resource instance
 */
export const EmployerProfileLocation = APILibrary.createResource<EmployerProfileLocationResource>(
  EmployerProfileLocationResource,
);
